var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.313 24.86h1.137c1.137 0 2.082-1.015 2.082-2.24 0-1.522-.542-1.82-1.434-2.135l-1.768-.612v4.987h-.017z",
    fill: "#F44380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.948.325C8.288.36.465 8.217.5 17.878c.035 9.66 7.893 17.482 17.553 17.447 9.66-.035 17.482-7.893 17.447-17.553C35.465 8.113 27.608.308 17.948.326zM21.955 18c1.365.473 3.203 1.488 3.203 4.62 0 2.695-2.118 4.865-4.708 4.865h-1.137V28.5c0 .718-.595 1.313-1.313 1.313a1.322 1.322 0 0 1-1.312-1.313v-1.015h-.63c-2.87 0-5.198-2.415-5.198-5.39 0-.717.595-1.313 1.313-1.313.717 0 1.312.596 1.312 1.313 0 1.523 1.155 2.765 2.573 2.765h.63v-5.915L14.045 18c-1.365-.473-3.202-1.488-3.202-4.62 0-2.695 2.117-4.865 4.707-4.865h1.138V7.5c0-.718.595-1.313 1.312-1.313.718 0 1.313.595 1.313 1.313v1.015h.63c2.87 0 5.197 2.415 5.197 5.39 0 .718-.595 1.313-1.312 1.313a1.322 1.322 0 0 1-1.313-1.313c0-1.522-1.155-2.765-2.572-2.765h-.63v5.915l2.642.945z",
    fill: "#F44380"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.485 13.397c0 1.523.543 1.82 1.435 2.135l1.768.613V11.14H15.55c-1.137 0-2.065 1.015-2.065 2.257z",
    fill: "#F44380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon_dollar.1f4ccd656460aa67e2cf7829a38244a5.svg";
export { ForwardRef as ReactComponent };